/**
 * src/styles/portalTheme.js
 *
 * The light palette used by the standalone PUBLIC portal pages — the ones
 * rendered outside the authenticated app shell for an external party who has
 * no Tryggr account (subcontractor, vendor, candidate).
 *
 * These pages cannot inherit the tenant theme: `useTheme` is bound to the
 * authenticated shell, and a portal deliberately mounts before it. So the
 * tokens have to come from somewhere, and a portal that hardcoded them inline
 * would be re-deciding brand colours per page — which is exactly what
 * CLAUDE.md's "never hardcode a hex in a component" exists to stop.
 *
 * Defining them once here keeps components referring to var(--…) as everywhere
 * else in the product, and gives the public pages a single place to change.
 */

export const PORTAL_THEME = {
  '--bg': '#f1f5f9',
  '--bg2': '#e8eef5',
  '--bg3': '#eef3f9',
  '--card': '#ffffff',
  '--fg': '#0f172a',
  '--fg2': '#1e293b',
  '--fg3': '#64748b',
  '--border': '#e2e8f0',
  '--accent': '#0284c7',
  '--accent-bg': 'rgba(2,132,199,0.08)',
  '--ok': '#15803d',
  '--warn': '#b45309',
  '--danger': '#b91c1c',
  '--danger-bg': 'rgba(185,28,28,0.08)',
};

/** Dark ground painted behind a lazy portal chunk while it loads. */
export const PORTAL_SUSPENSE_BG = '#141210';
